import React from "react";
import { useNavigate } from "react-router-dom";
import { useGetDotInspectionsPaginatedQuery } from "../../api/dotInspectionsApi";
import { AddButton } from "../../components/common/AddButton";
import PageTitle from "../../components/common/PageTitle";
import { DotInspectionsIcon } from "../../components/common/pageIcons";
import { DEFAULT_DATA_TABLE_PAGE_SIZE } from "../../constants/dataTable";
import DotInspectionsTable from "./components/DotInspectionsTable";
import PageLayout from "../../components/layout/PageLayout";
import { useDataTablePagination } from "../../hooks/useDataTablePagination";

const DotInspectionsPage: React.FC = () => {
  const navigate = useNavigate();
  const {
    items: inspections,
    isLoading,
    isLoadingRows,
    isLoadingMore,
    totalCount,
    hasNextPage,
    handleSearchChange,
    handleLoadMore,
  } = useDataTablePagination(
    useGetDotInspectionsPaginatedQuery,
    DEFAULT_DATA_TABLE_PAGE_SIZE
  );

  return (
    <PageLayout>
      <PageTitle
        title="DOT Inspections"
        icon={<DotInspectionsIcon />}
        titleVariant="h4"
        subtitle="Manage and track DOT inspections"
        actions={
          <AddButton onClick={() => navigate("/dot-inspections/create")}>
            Add Inspection
          </AddButton>
        }
      />

      <DotInspectionsTable
        inspections={inspections}
        isLoading={isLoading}
        totalCount={totalCount}
        hasNextPage={hasNextPage}
        isLoadingMore={isLoadingMore}
        isLoadingRows={isLoadingRows}
        onLoadMore={handleLoadMore}
        enableSearch={true}
        onSearchChange={handleSearchChange}
      />
    </PageLayout>
  );
};

export default DotInspectionsPage;
